const theme =  {
  title: 'Default Theme',

  colors: {
    primary: '#539dff',
    secondary: '#0078B5',
    fontPrimary: '#49475B',
    fontSecondary: '#9d9d9d',
    background: '#EBEBEB'
  }
}

export default theme;